import {useTranslation} from 'react-i18next';
import Download from '../../../assets/images/svgicons/cloud-download.svg';

type ResourcesTypes = {
  classResource: [];
};
function ClassResources(Props: ResourcesTypes) {
  const {t} = useTranslation();
  const download = (ele: any) => {
    const location = ele?.attributes.location;
    const name = ele?.attributes.name;
    const fileExtention = name.split('.');

    switch (fileExtention[fileExtention.length - 1]) {
      case 'txtx':
        break;
      default:
        Object.assign(document.createElement('a'), {
          target: '_blank',
          rel: 'noopener noreferrer',
          href: location,
        }).click();
      break;
    }
  };
  return (
    <section className="mx-auto xl:px-32 lg:px-8 md:px-8 px-5 my-16">
      <h3 className="font-light tracking-wider text-xl font-barlowLight border-t pt-16">
      <span dangerouslySetInnerHTML={{ __html: t('Program.classResources') }} /></h3>
      <div className="bg-fillMidGrayCard rounded-xl my-12">
        {Props.classResource &&
          Props.classResource?.map((ele: any, index: number) => {
            return (
              <div
                key={`courses-${index}`}
                className="flex justify-between border-b p-4 article px-8"
              >
                <p className="font-opensansMedium text-base">{ele?.attributes?.name}</p>
                <a
                  key={ele?.attributes?.name}
                  download={ele?.attributes?.name}
                  onClick={() => download(ele)}
                >
                  <img className="cursor-pointer" src={Download} alt="cloud-download" />
                </a>
              </div>
            );
          })}
      </div>
    </section>
  );
}

export default ClassResources;
